import { getFieldsRootNodes, getTypesRootNodes } from "@omnia/shared/layers/menu/nodes"
import { LmNode, LmPath, LocaleString, NodesContext, selectMany, str } from "../omnia"
import { LayerViewModel } from "@omnia/shared/layers/layerViewModel"

export interface LmRoot {

    id: string
    name: string
    icon?: string

    provider(context: NodesContext<LayerViewModel>): LmNode[]
    setDefaults(rootNodes: LmNode[])
    getPathsToField(rootNodes: LmNode[], fieldId: number): LmPath[]

}

export function getMenuRoots(): LmRoot[] {

    return [
        {
            id: "fields",
            name: str.Fields,
            icon: "icon icon-fields",
            provider: getFieldsRootNodes,
            setDefaults: () => { },
            getPathsToField: getFieldsPathToField
        },

        {
            id: "types",
            name: "Layer types" as LocaleString,
            icon: "fas fa-layer-group",
            provider: getTypesRootNodes,
            setDefaults: setTypesDefaults,
            getPathsToField: getTypesPathsToField
        },

    ]

}


function getFieldsPathToField(rootNodes: LmNode[], fieldId: number) {

    const predicate = (node: LmNode) => node && node.field && (node.field.fieldId == fieldId) && (node.class == "field")

    const path = findSinglePath(rootNodes, predicate, n => n.getChildren(true))

    return path ? [path] : undefined

}

function getTypesPathsToField(rootNodes: LmNode[], fieldId: number) {

    const predicate = (node: LmNode) => node && node.field && (node.field.fieldId == fieldId) && ((node.class == "field") || (node.class == "layer"))

    return findMultiplePaths(rootNodes, predicate, n => n.expanded ? n.getChildren(true) : undefined)

}


function setTypesDefaults(rootNodes: LmNode[]) {

    rootNodes.filter(n => n.class == "type-group").forEach(n => n.expanded = true)

}

export function findPathToNode(nodes: LmNode[], predicate: (node: LmNode) => boolean, create = false) {
    return findSinglePath(nodes, predicate, n => n.getChildren(create))
}

export function findPathToParent(nodes: LmNode[], childPredicate: (node: LmNode) => boolean, create = false) {
    return findPathToNode(nodes, n => (n.getChildren(create) || []).some(childPredicate), create)
}


export function expandPath(path: LmPath) {
    path.forEach(p => p.expanded = true)
}

function findSinglePath(nodes: LmNode[], predicate: (node: LmNode) => boolean, getChildren: (node: LmNode) => LmNode[]): LmPath {

    for (const node of nodes) {

        if (predicate(node)) {
            return [node]
        }

        const children = getChildren(node)

        const match = children ? findSinglePath(children, predicate, getChildren) : undefined

        if (match) {
            return [node].concat(match)
        }

    }
}

export function findMultiplePaths(nodes: LmNode[], predicate: (node: LmNode) => boolean, getChildren: (node: LmNode) => LmNode[]) {

    return selectMany(nodes.map(getMatches).filter(p => !!p))

    function getMatches(node: LmNode): LmPath[] {

        if (predicate(node)) {
            return [[node]]
        }

        const children = getChildren(node)

        const matches = children ? findMultiplePaths(children, predicate, getChildren) : undefined

        return matches
            ? matches.map(m => [node].concat(m))
            : undefined

    }
}

